import { LINKPAY_COOKIES } from "../../pages/constants";
import { Nullable } from "../types/types";
import { useCookie } from "./useCookie";

export interface ILinkPayCookies {
	hasDefaultCard: Nullable<string>;
	accessToken: Nullable<string>;
	uid: Nullable<string>;
	isAuthenticated: boolean;
	hasPaymentMethod: boolean;
	isFullySetup: boolean;
}

export const useLinkPayCookies = (): ILinkPayCookies => {
	const { cookieValue: hasDefaultCard } = useCookie<string>(
		LINKPAY_COOKIES.HAS_DEFAULT_CARD,
		null,
		{ retryInterval: 5, refreshOnRetrySuccess: true, maxRetryDuration: 60 }
	);
	const { cookieValue: accessToken } = useCookie<string>(LINKPAY_COOKIES.ACCESS_TOKEN, null, {
		retryInterval: 5,
		refreshOnRetrySuccess: true,
		maxRetryDuration: 60,
	});
	const { cookieValue: uid } = useCookie<string>(LINKPAY_COOKIES.UID, null, {
		retryInterval: 5,
		refreshOnRetrySuccess: true,
		maxRetryDuration: 60,
	});

	const isAuthenticated = !!(accessToken && uid);
	const hasPaymentMethod = !!hasDefaultCard;
	const isFullySetup = !!(hasDefaultCard && accessToken && uid);

	return {
		hasDefaultCard,
		accessToken,
		uid,
		isAuthenticated,
		hasPaymentMethod,
		isFullySetup,
	};
};
